import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Flex,
  Text,
  Spinner,
} from '@chakra-ui/react';
import videoThumbnail from 'assets/img/dashboards/video-thumbnail.jpg';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';

const LlmCodeGeneration = () => {
  const [campaign, setCampaign] = useState('');
  const [productLink, setProductLink] = useState('');
  const [industry, setIndustry] = useState('');
  const [theme, setTheme] = useState('');
  const [videoExpanded, setVideoExpanded] = useState(false);
  const [step, setStep] = useState(1); // Step state to control form steps
  const [logo, setLogo] = useState(null); // State for user logo
  const [productImage, setProductImage] = useState(null); // State for product image
  const videoRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (videoRef.current && !videoRef.current.contains(event.target)) {
        setVideoExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleVideo = () => {
    setVideoExpanded(!videoExpanded);
  };

  const handleNext = () => {
    setStep(2);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append('type', campaign);
    formData.append('url', productLink);
    formData.append('industry', industry);
    formData.append('theme', theme);
    formData.append('logo', logo);
    formData.append('productImage', productImage);

    try {
      const res = await axios.post(
        'https://bounce.mailamp.in/template',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (res.data.success) {
        const html = res.data.htmlString;
        console.log('🚀 ~ handleSubmit ~ html:', html);
        localStorage.setItem('emailTemplateHtml', html);
        history.push('/admin/stripo');
      }
    } catch (error) {
      console.log(error);
      const errorMessage = error.response?.data || 'An error occurred';
      console.log('🚀 ~ handleSubmit ~ errorMessage:', errorMessage);
      toast.error(errorMessage.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 120,
        damping: 10,
        duration: 0.5,
      }}
    >
      <Flex justify="center" align="center" h="100vh" bg="#f6f3fc">
        <Box
          w="100%"
          maxW="2xl"
          px="6"
          py="8"
          bg="white"
          boxShadow="lg"
          rounded="lg"
        >
          <form onSubmit={handleSubmit}>
            {step === 1 && (
              <>
                <FormControl isRequired>
                  <FormLabel>What email campaign do you want to run?</FormLabel>
                  <Select
                    placeholder="Select campaign"
                    value={campaign}
                    onChange={(e) => setCampaign(e.target.value)}
                  >
                    <option value="Abandoned Cart">Abandoned Cart</option>
                    <option value="Newsletter">Newsletter</option>
                    <option value="Promo Invitation Holidays">
                      Promo Invitation Holidays
                    </option>
                    <option value="Events Discount">Events Discount</option>
                    <option value="Teaser Announcement">
                      Teaser Announcement
                    </option>
                    <option value="Food Baking">Food Baking</option>
                    <option value="Order Confirmation, Confirmation, Trigger Invoice">
                      Order Confirmation, Confirmation, Trigger Invoice
                    </option>
                    <option value="Alerts and Notifications Trigger">
                      Alerts and Notifications Trigger
                    </option>
                    <option value="Announcement Terms of Service Customer Service">
                      Announcement Terms of Service Customer Service
                    </option>
                    <option value="Alerts and Notifications Holidays">
                      Alerts and Notifications Holidays
                    </option>
                    <option value="Software and Technology Business Manufacturing">
                      Software and Technology Business Manufacturing
                    </option>
                    <option value="Holidays">Holidays</option>
                    <option value="Confirmation, Alerts and Notifications">
                      Confirmation, Alerts and Notifications
                    </option>
                    <option value="Cold Emails, Signature, Personal Note, Outreach, B2B">
                      Cold Emails, Signature, Personal Note, Outreach, B2B
                    </option>
                    <option value="Events, Discount, Apology, Follow-Up, Coupon">
                      Events, Discount, Apology, Follow-Up, Coupon
                    </option>
                    <option value="Survey and Feedback, Apology, SaaS">
                      Survey and Feedback, Apology, SaaS
                    </option>
                    <option value="Apology, Signature, Personal Note">
                      Apology, Signature, Personal Note
                    </option>
                    <option value="Survey and Feedback, Annual Review">
                      Survey and Feedback, Annual Review
                    </option>
                    <option value="Promo Product Update Alerts and Notifications Marketing">
                      Promo Product Update Alerts and Notifications Marketing
                    </option>
                  </Select>
                </FormControl>

                <FormControl mt="4" isRequired>
                  <FormLabel>What is your industry?</FormLabel>
                  <Select
                    placeholder="Select industry"
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                  >
                    <option value="Cosmetics">Cosmetics</option>
                    <option value="Kids Toys">Kids Toys</option>
                    <option value="E-commerce">E-commerce</option>
                    <option value="Fashion">Fashion</option>
                    <option value="Sports">Sports</option>
                    <option value="Education">Education</option>
                    <option value="Photography">Photography</option>
                    <option value="Hobbies">Hobbies</option>
                    <option value="Tattoo">Tattoo</option>
                    <option value="Holiday">Holiday</option>
                    <option value="History Purpose Usage">
                      History Purpose Usage
                    </option>
                    <option value="Wedding">Wedding</option>
                    <option value="Construction">Construction</option>
                    <option value="Women's Day Sale">Women's Day Sale</option>
                    <option value="Furniture, Interior and DIY E-Commerce">
                      Furniture, Interior and DIY E-Commerce
                    </option>
                    <option value="Gadgets">Gadgets</option>
                    <option value="Travel Airline">Travel Airline</option>
                    <option value="Gadgets E-Commerce">
                      Gadgets E-Commerce
                    </option>
                    <option value="Crowdfunding">Crowdfunding</option>
                    <option value="Business">Business</option>
                    <option value="Design">Design</option>
                    <option value="Webinars">Webinars</option>
                    <option value="Pets">Pets</option>
                    <option value="Non-Profit">Non-Profit</option>
                    <option value="Finance">Finance</option>
                    <option value="Confirmation">Confirmation</option>
                    <option value="Movies">Movies</option>
                    <option value="Software and Technology Business Manufacturing Programming">
                      Software and Technology Business Manufacturing Programming
                    </option>
                    <option value="Business Manufacturing">
                      Business Manufacturing
                    </option>
                    <option value="Software and Technology, Design">
                      Software and Technology, Design
                    </option>
                    <option value="Software and Technology, Hobbies">
                      Software and Technology, Hobbies
                    </option>
                  </Select>
                </FormControl>

                <Flex justify="center">
                  <Button
                    variant="brand"
                    w="100%"
                    mt="6"
                    colorScheme="blue"
                    onClick={handleNext}
                    isDisabled={!campaign || !industry}
                  >
                    Next
                  </Button>
                </Flex>
              </>
            )}

            {step === 2 && (
              <>
                <FormControl mt="4">
                  <FormLabel>
                    Please paste the weblink of the product you want to create
                    email for?
                  </FormLabel>
                  <Input
                    placeholder="https://your-website.com/products/your-product"
                    type="url"
                    value={productLink}
                    onChange={(e) => setProductLink(e.target.value)}
                  />
                </FormControl>

                <FormControl mt="4" isRequired>
                  <FormLabel>What is your theme?</FormLabel>
                  <Select
                    placeholder="Select theme"
                    value={theme}
                    onChange={(e) => setTheme(e.target.value)}
                  >
                    <option value="Black and Blue">Black and Blue</option>
                    <option value="White and Blue">White and Blue</option>
                    <option value="Orange and Black">Orange and Black</option>
                    <option value="Purple and White">Purple and White</option>
                    <option value="Orange and White">Orange and White</option>
                    <option value="Black and White">Black and White</option>
                    <option value="Orange and Blue">Orange and Blue</option>
                    <option value="White and Grey">White and Grey</option>
                    <option value="Pink and White">Pink and White</option>
                    <option value="White and Yellow">White and Yellow</option>
                    <option value="White and Green">White and Green</option>
                    <option value="Brown and Yellow">Brown and Yellow</option>
                    <option value="White">White</option>
                    <option value="Yellow">Yellow</option>
                    <option value="Maroon">Maroon</option>
                    <option value="Pink">Pink</option>
                    <option value="Purple">Purple</option>
                    <option value="Black">Black</option>
                    <option value="Light Blue">Light Blue</option>
                    <option value="Black, Orange and White">
                      Black, Orange and White
                    </option>
                    <option value="White and Dark Pink">
                      White and Dark Pink
                    </option>
                    <option value="Sky Blue and White">
                      Sky Blue and White
                    </option>
                    <option value="Light Brown and White">
                      Light Brown and White
                    </option>
                    <option value="Light Blue and White">
                      Light Blue and White
                    </option>
                  </Select>
                </FormControl>

                <FormControl mt="4">
                  <FormLabel>
                    Upload your logo
                    <br /> (We only accept jpg,png,gif file formats. Recommended
                    size is 200 *60)
                  </FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setLogo(e.target.files[0])}
                  />
                </FormControl>

                <FormControl mt="4">
                  <FormLabel>
                    Upload your product image <br /> (We only accept jpg,png,gif
                    file formats.)
                  </FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setProductImage(e.target.files[0])}
                  />
                </FormControl>

                <Flex justify="center">
                  <Button
                    variant="brand"
                    w="100%"
                    mt="6"
                    colorScheme="blue"
                    type="submit"
                    isLoading={loading}
                    isDisabled={loading}
                    loadingText="Please wait..."
                    spinner={<Spinner size="sm" />}
                  >
                    Submit
                  </Button>
                </Flex>
              </>
            )}
          </form>
          <Box
            ref={videoRef}
            position="absolute"
            bottom="200"
            right="5"
            cursor="pointer"
            onClick={toggleVideo}
            zIndex="999"
          >
            {videoExpanded ? (
              // Expanded video
              <>
                <iframe
                  width="640"
                  height="360"
                  src="https://www.youtube.com/embed/J3MklSK5C6A"
                  title="product site url"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicyolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
                {/* <iframe
                  title="vimeo-player"
                  src="https://player.vimeo.com/video/949880019?h=e8a7dc13e7"
                  width="640"
                  height="360"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                ></iframe> */}
              </>
            ) : (
              <>
                <img
                  src={videoThumbnail}
                  alt="Video thumbnail"
                  width="200"
                  height="200"
                />
                <Text>Click on the thumbnail to see demo video</Text>
              </>
            )}
          </Box>
        </Box>
      </Flex>
    </motion.div>
  );
};

export default LlmCodeGeneration;
